import {InvalidateOptions, useQuery, useQueryClient} from '@tanstack/react-query';

import {apiClient} from '../../../../utils/api-client';
import {uniqueBy} from '../../../../utils/array';

const RECENT_DOCS_LIMIT = 20;
const POLLING_INTERVAL = 3000;

function getRecentDocsRequest() {
    return apiClient
        .get<PageResponse<EditModeDoc>>({
            path: `editor-documents-service/api/user/documents/recent?limit=${RECENT_DOCS_LIMIT}`
        })
        .then((result) => result.data);
}

export function useRecentDocsQuery() {
    return useQuery({
        queryKey: ['editModeRecent'],
        queryFn: getRecentDocsRequest,
        refetchInterval: POLLING_INTERVAL
    });
}

export function useRecentDocsQueryCache() {
    const queryClient = useQueryClient();
    const queryKey = ['editModeRecent'];

    function addDocument(document: EditModeDoc) {
        queryClient.setQueriesData<EditModeDoc[] | undefined>(
            {queryKey},
            (currentState) =>
                currentState &&
                uniqueBy('id', [document, ...currentState]).slice(0, RECENT_DOCS_LIMIT)
        );
    }

    function invalidate() {
        queryClient.invalidateQueries({queryKey}, {refetchType: 'inactive'} as InvalidateOptions);
    }

    return {addDocument, invalidate};
}
